// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__tF3YW","content":"styles_content__15Wba","tableWrap":"styles_tableWrap__1zpT8"};